import styled from "@emotion/styled/macro";
import { useMediaQuery } from "react-responsive";
import { SideNav } from "components/organisms/SideNav";
import { maxWidth } from "helpers/styleConstants";

type props = { children: React.ReactNode; hideNav: boolean };

const SideNavWithContent = ({ children, hideNav }: props) => {
  const isMobile = useMediaQuery({ maxWidth: maxWidth });

  return (
    <SideNavWithContentContainer isMobile={isMobile}>
      <SideNavContainer hideNav={hideNav}>
        <SideNav></SideNav>
      </SideNavContainer>
      {children}
    </SideNavWithContentContainer>
  );
};

const SideNavContainer = styled.div<{ hideNav: boolean }>`
  visibility: ${({ hideNav }) => (hideNav ? "hidden" : "visible")};
`;

const SideNavWithContentContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  & :first {
    width: 100%;
  }
  height: 100vh;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  background-color: #fffbf0;
`;

export { SideNavWithContent };
